var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-3"},[_c('p',[_vm._v("Now loading: "+_vm._s(_vm.message)+"...")]),_c('v-progress-circular',{attrs:{"indeterminate":"","size":75}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }